<template>
    <div>
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

            <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Copy Payroll Attendance</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="2" md="2">
                        <p><v-icon color="error">*</v-icon><b>Year</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="calendar_year"
                            :items="calendar_year_list" item-text="name" item-value="id" label="Year"
                            @change="getSalaryMonths()" outlined persistent-hint hint="Please Select Year" />
                    </v-col>
                    <v-col cols="12" sm="2" md="2" v-if="this.salary_month_list.length > 0">
                        <p><v-icon color="error">*</v-icon><b>Salary Month</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="salary_month"
                            :items="salary_month_list" item-text="sal_mon" item-value="id" label="Month"
                            @change="getEmployees()" outlined persistent-hint hint="Please Select Month" />
                    </v-col>
                    <v-col cols="12" sm="2" md="2" v-if="this.salary_month_list.length > 0">
                        <p><v-icon color="error">*</v-icon><b>Employee Type</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="employee_type"
                            @change="getEmployees()" :items="employee_type_list" item-text="name" item-value="id"
                            label="Employee Type" outlined persistent-hint hint="Please Select Employee Type" />
                    </v-col>

                    <v-col cols="12" sm="3" md="3" v-if="this.salary_month_list.length > 0">
                        <p><v-icon color="error">*</v-icon><b>Employee Section</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required @change="getEmployees()"
                            v-model="employee_section" :items="employee_section_list" item-text="name" item-value="id"
                            label="Employee Section" outlined persistent-hint hint="Please Select Employee Section" />
                    </v-col>
                    <v-col cols="12" sm="3" md="3" v-if="this.salary_month_list.length > 0">
                        <p><v-icon color="error">*</v-icon><b>Employee Shift</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="shift" @change="getEmployees()"
                            :items="employee_shift_list" item-text="name" item-value="id" label="Employee Shift"
                            outlined persistent-hint hint="Please Select Employee Shift" />
                    </v-col>
                </v-row>
                <v-row dense justify="center">
                    <v-col cols="12" sm="3" md="3" v-if="this.employee_list!=''">
                        <p><v-icon color="error">*</v-icon><b>Employee </b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="employee" :items="employee_list"
                            item-text="name" item-value="id" label="Employee" multiple outlined persistent-hint
                            hint="Please Select Employee" />
                    </v-col>
                    <v-col cols="12" sm="3" md="3" v-if="this.employee_list!=''">
                        <p><v-icon color="error">*</v-icon><b>Leave Status </b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="leave_status"
                            :items="leave_status_list" item-text="status" item-value="id" label="Leave Status" outlined
                            persistent-hint hint="Please Select Leave Status" />
                    </v-col>
                </v-row>
                <v-row justify="center" v-if="this.employee_list!=''">
                    <v-radio-group v-model="radios" row mandatory class="ma-2 no-display">
                        <v-radio label="FETCH(No Changes Will Be Done In Salary Register And Leaves)" value="FETCH"
                            color="#0f2027"></v-radio>
                        <v-radio label="SYNC(Data Will Be Synced For Leaves And Salary Register)" value="SYNC"
                            color="#0f2027"></v-radio>
                    </v-radio-group>
                </v-row>
                <v-row justify="center" v-if="this.leave_status">
                    <v-btn color="warning" @click="copyAttendance()">Save</v-btn>
                </v-row>
            </v-card>

            <!-- {{ inst_attendance_list }} -->

            <v-card class="box" v-if="inst_attendance_list.length > 0">
                <v-toolbar flat class="toolbar">
                    <v-toolbar-title>{{ table_title }} View </v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row dense>
                    <v-col cols="12" sm="4" md="4">
                        <v-btn color="success" outlined rounded>
                            <download-excel class="mr-2 pb-3 pt-2" :data="inst_attendance_list" :fields="table_fields"
                                worksheet="CopyPayrollAttendance" name="CopyPayrollAttendance.xls">
                                <v-icon dark>mdi-file-excel</v-icon> Export
                            </download-excel>
                        </v-btn>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                        <v-text-field v-model="search" class="mr-2 pb-3 pt-2" append-icon="search" label="Search"
                            single-line hide-details> </v-text-field>
                    </v-col>
                </v-row>
                <v-data-table class="mytable" :headers="headers" :items="inst_attendance_list" :search="search"
                    v-model="selected" item-key="inst_id" show-select>
                    <template v-slot:item="{ item }">
                        <tr :class="{ 'highlighted-row': !item.sync_salary_register }" @click="select(!isSelected)">
                            <td>
                                <v-simple-checkbox :value="selected.some((s) => s.inst_id === item.inst_id)"
                                    @input="(value) => select(item, value)" />
                            </td>
                            <td>{{ item.inst }}</td>
                            <td>{{ item.present }}</td>
                            <td>{{ item.sal_reg_present }}</td>
                            <td>{{ item.remark }}</td>
                            <td>{{ item.att_data.HPL }}</td>
                            <td>{{ item.att_data.Late_Early_Instance }}</td>zz
                            <td>{{ item.att_data.Holiday }}</td>
                            <td>{{ item.att_data.LWP }}</td>
                            <td>{{ item.att_data.HLWP }}</td>
                            <td>{{ item.att_data.ML }}</td>
                            <td>{{ item.att_data.COFF }}</td>
                            <td>{{ item.att_data.OD }}</td>
                            <td>{{ item.att_data.SPL }}</td>
                            <td>{{ item.att_data.Present }}</td>
                            <td>{{ item.att_data.Absent }}</td>
                        </tr>
                    </template>
                </v-data-table>
                <v-row justify="center" dense v-if="this.selected.length > 0">
                    <v-col cols="12" sm="2"> </v-col>
                    <v-col cols="12" sm="2">
                        <v-btn color="warning" @click="copyAttendanceSync()"
                            :disabled="employee_list!='' ? false : true">SYNC</v-btn>
                    </v-col>
                </v-row>
                <v-row justify="center" dense v-if="this.selected.length > 0">
                    <strong>Total Selected - {{ selected.length }}</strong>
                </v-row>
            </v-card>
        </v-container>
    </div>
    <!-- /. root div -->
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data: () => ({
            selected: [],
            total_teachers: [],
            loader: false,
            radios: null,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            overlay: false,
            title: "",
            description: "",
            search: "",
            headers: [
                { text: "Employee", value: "inst" },
                { text: "Biometric Present Count", value: "present" },
                { text: "Salary Register Present Count", value: "sal_reg_present" },
                { text: "Remark", value: "remark" },
                { text: "HPL", value: "att_data.HPL" },
                { text: "Late_Early_Instance", value: "att_data.Late_Early_Instance" },
                { text: "Holiday", value: "att_data.Holiday" },
                { text: "LWP", value: "att_data.LWP" },
                { text: "HLWP", value: "att_data.HLWP" },
                { text: "ML", value: "att_data.ML" },
                { text: "COFF", value: "att_data.COFF" },
                { text: "OD", value: "att_data.OD" },
                { text: "SPL", value: "att_data.SPL" },
                { text: "Present", value: "att_data.Present" },
                { text: "Absent", value: "att_data.Absent" },
            ],
            table_fields: {
                Employee: "inst",
                "Biometric Present Count": "present",
                "Salary Register Present Count": "sal_reg_present",
                Remark: "remark",
                HPL: "att_data.HPL",
                Late_Early_Instance: "att_data.Late_Early_Instance",
                Holiday: "att_data.Holiday",
                LWP: "att_data.LWP",
                HLWP: "att_data.HLWP",
                ML: "att_data.ML",
                COFF: "att_data.COFF",
                SPL: "att_data.SPL",
                Absent: "att_data.Absent",
            },
            calendar_year_list: [],
            calendar_year: "",
            salary_month_list: [],
            salary_month: "",
            employee_type_list: [],
            employee_type: "",
            employee_section_list: [],
            employee_shift_list: [],
            employee_section: "",
            shift: null,
            employee_list: [],
            employee: null,
            leave_status_list: [],
            leave_status: "",
            inst_attendance_list: [],
            table_title: null,
            default_value: null,
        }),
        methods: {

            select(item, value) {
                if (value) {
                    this.selected.push(item);
                } else {
                    this.selected = this.selected.filter((selectedItem) => selectedItem.inst_id !== item.inst_id);
                }
            },
            copyAttendanceSync() {
                this.total_teachers = [];
                this.employee_list;
                for (var i = 0; i < this.selected.length; i++) {
                    this.total_teachers.push(this.selected[i].inst_id);
                }
                if (this.total_teachers.length <= 0) {
                    this.showSnackbar("#b71c1c", "Please select Teachers!"); // show snackbar
                }
                if (!confirm("Are You Sure You Want To Sync...?")) return;
                this.table_title = this.radios;
                const data = {
                    employee_list: this.total_teachers,
                    leave_status: this.leave_status,
                    salary_month: this.salary_month,
                    employee_type: this.employee_type,
                    section: this.employee_section,
                    shift: this.shift,
                    type: "SYNC",
                };
                this.overlay = true;
                axios
                    .post("/EmployeeBiometric/copyAttendance", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("green", "Synced Successfully");
                            this.inst_attendance_list = res.data.inst_attendance_list;
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.onerror(error);
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        this.selected = [];
                    });
            },
            onerror(error) {
                let msg = "";
                if (error.response) {
                    msg = "Something went wrong.";
                } else if (error.request) {
                    msg = "Please try again.";
                } else {
                    msg = "Un-expected error.";
                }
                this.showSnackbar("error", msg);
            },
            setNull() {
                (this.employee_list = []),
                    (this.employee = ""),
                    (this.leave_status_list = []),
                    (this.leave_status = ""),
                    (this.employee_type_list = []),
                    (this.employee_type = ""),
                    (this.employee_section_list = []),
                    (this.employee_shift_list = []),
                    (this.employee_section = "");
                this.shift = null;
                (this.salary_month_list = []), (this.salary_month = "");
            },

            copyAttendance() {
                this.table_title = this.radios;
                const data = {
                    employee_list: this.employee,
                    leave_status: this.leave_status,
                    salary_month: this.salary_month,
                    employee_type: this.employee_type,
                    section: this.employee_section,
                    shift: this.shift,
                    type: this.radios,
                };
                this.overlay = true;
                axios
                    .post("/EmployeeBiometric/copyAttendance", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.inst_attendance_list = res.data.inst_attendance_list;
                            //this.showSnackbar("green", "Synced Successfully");
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.onerror(error);
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            getEmployees() {
                this.employee_list = []
                this.employee = null
                const data = {
                    employee_type: this.employee_type,
                    section: this.employee_section,
                    shift: this.shift,
                    salary_month: this.salary_month
                };
                this.overlay = true;
                axios
                    .post("/EmployeeBiometric/getEmployees", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.employee_list = res.data.instructor_list;
                            // this.employee = res.data.instructor_list_id;
                            //this.employee = this.employee_list[0];
                            this.leave_status_list = res.data.leave_status_list;
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.onerror(error);
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            getSalaryMonths() {
                //this.setNull();
                const data = {
                    year: this.calendar_year,
                };
                this.overlay = true;
                axios
                    .post("/Payroll/getSalaryMonth", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.salary_month_list = res.data.sal_month_list;
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.onerror(error);
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            onLoad() {
                axios
                    .post("EmployeeBiometric/getPayrollInfo")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            (this.ay_list = res.data.ay_list), (this.ay = res.data.curreny_ay);
                            this.calendar_year_list = res.data.calendar_year_list;
                            this.employee_type_list = res.data.employee_type_list;
                            this.employee_section_list = res.data.employee_section_list;
                            this.employee_shift_list = res.data.employee_shift_list;
                            this.employee_type = this.employee_type_list[0].id;
                            this.employee_section = this.employee_section_list[0].id;
                            this.overlay = false;
                        } else {
                            this.showSnackbar("#b71c1c", res.data.status_reason);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
        mounted() {
            this.onLoad();
        },
        watch: {},
    };
</script>
<style scoped>
    .highlighted-row {
        background-color: yellow !important;
        /* Light cyan background */
    }
</style>